// extracted by mini-css-extract-plugin
export default {"NewProjectDialog":"NewProjectDialog_NewProjectDialog__tVkoD"};